import React, { useState } from 'react';
import s from './ReferencesModal.module.css';
import { Reference } from '../../../../shared/types/projectTypes';
import IconClose from '../../../../shared/ui/icons/IconClose';
import IconCopy from '../../../../shared/ui/icons/IconCopy';
import IconOpenReferences from '../../../../shared/ui/icons/IconOpenReferences';
import IconPasteReferences from '../../../../shared/ui/icons/IconPasteReferences';
interface ReferencesModalProps {
    isOpen: boolean;
    onClose: () => void;
    references: Reference[];
    onSearchAgain: () => void;
    onCopyReference: (id: number, url: string) => void;
    onPasteReference: (id: number, url: string) => void;
}

const ReferencesModal: React.FC<ReferencesModalProps> = ({
    isOpen,
    onClose,
    references,
    onSearchAgain,
    onCopyReference,
    onPasteReference,
}) => {
    const [currentPage, setCurrentPage] = useState(0);
    const itemsPerPage = 3;
    const totalPages = Math.ceil(references.length / itemsPerPage);

    const getCurrentReferences = () => {
        const start = currentPage * itemsPerPage;
        return references.slice(start, start + itemsPerPage);
    };

    const nextPage = () => {
        setCurrentPage((prev) => (prev + 1) % totalPages);
    };

    const prevPage = () => {
        setCurrentPage((prev) => (prev - 1 + totalPages) % totalPages);
    };

    if (!isOpen) return null;

    return (
        <div className={s.modalOverlay} onClick={onClose}>
            <div className={s.modalContent} onClick={(e) => e.stopPropagation()}>
                <button className={s.closeButton} onClick={onClose}>
                    <IconClose />
                </button>

                <div className={s.header}>
                    <h2 className={s.title}>Choose the references for your post</h2>
                    <p className={s.subtitle}>
                        Want to see another options?
                        <button className={s.searchAgainButton} onClick={onSearchAgain}>
                            Try the search again
                        </button>
                    </p>
                </div>

                <div className={s.referencesGrid}>
                    {getCurrentReferences().map((ref) => {
                        const domain = new URL(ref.url).hostname.replace(/^www\./, '');
                        return (
                            <div key={ref.id} className={s.referenceCard}>
                                <div className={s.imageContainer}></div>

                                <div className={s.cardContent}>
                                    <h3 className={s.referenceTitle}>{ref.title}</h3>
                                    <p className={s.referenceSource}>Source: {domain}</p>
                                    {/* <p className={s.referenceDescription}>
                                        {ref.description || 'No description available'}
                                    </p> */}

                                    <div className={s.actionButtons}>
                                        <button
                                            className={s.actionButton}
                                            title="View reference"
                                            onClick={() =>
                                                window.open(
                                                    ref.url,
                                                    '_blank',
                                                    'noopener,noreferrer',
                                                )
                                            }
                                        >
                                            <IconOpenReferences width={16} height={16} />
                                        </button>
                                        <button
                                            className={s.actionButton}
                                            title="Copy link"
                                            onClick={() => onCopyReference(ref.id, ref.url)}
                                        >
                                            <IconCopy />
                                        </button>
                                        <button
                                            className={s.actionButton}
                                            title="Insert to editor"
                                            onClick={() => onPasteReference(ref.id, ref.url)}
                                        >
                                            <IconPasteReferences />
                                        </button>
                                    </div>
                                </div>
                            </div>
                        );
                    })}
                </div>

                {totalPages > 1 && (
                    <div className={s.pagination}>
                        <button
                            className={s.navButton}
                            onClick={prevPage}
                            disabled={totalPages <= 1}
                        >
                            ←
                        </button>
                        <button
                            className={s.navButton}
                            onClick={nextPage}
                            disabled={totalPages <= 1}
                        >
                            →
                        </button>
                    </div>
                )}
            </div>
        </div>
    );
};

export default ReferencesModal;
